import { getAxiosInstance } from "../../../api";

export const approveStockData = async (stockId) => {
  const api = await getAxiosInstance();
  let body = { id: stockId };
  try {
    const response = await api.post(
      `/verification/reissue/approve`,body
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const rejectStockData = async (stockId) => {
  const api = await getAxiosInstance();
  let body = { id: stockId };
  try {
    const response = await api.post(`/verification/reissue/reject`, body);
    return response;
  } catch (error) {
    return error.response.data;
  }
};